export function getFsrRiskLabel(band: "low" | "medium" | "high"): string {
	switch (band) {
		case "low":
			return "Low risk";
		case "medium":
			return "Medium risk";
		case "high":
			return "High risk";
	}
}
